import { where } from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByQueries, getDocById, updateDoc } from './collectionBaseWorker';

export const getCompanyById = async ({ id }) => {
    return await getDocById({ collection: Collection.COMPANIES, id: id })
}

export const getAllCompaniesByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.COMPANIES, clienteId: clienteId })
}

export const addCompany = async ({ data }) => {
    await addDoc({ collection: Collection.COMPANIES, data: data })
}

export const updateCompanyById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.COMPANIES, id: id, data: data })
}

export const removeCompanyById = async ({ id }) => {
    await deleteDoc({ collection: Collection.COMPANIES, id: id })
}

export const addCompanyCharge = async ({ data }) => {
    await addDoc({ collection: Collection.COMPANIES_CHARGES, data: data })
}

export const getAllChargesByCompanyId = async ({ companyId }) => {
    return await getAllDocsByQueries({
        collection: Collection.COMPANIES_CHARGES,
        queries: [
            where(WhereField.COMPANY_ID, "==", companyId)
        ]
    })
}

export const getAllCompanyChargesByCashiers = async ({ caixasIds }) => {
    var result = [];
    const chunkSize = 10;
    for (let i = 0; i < caixasIds.length; i += chunkSize) {
        const cashiersSliced = caixasIds.slice(i, i + chunkSize);
        if (cashiersSliced.length > 0) {
            const items = await getAllDocsByQueries({
                collection: Collection.COMPANIES_CHARGES,
                queries: [
                    where(WhereField.CASHIER__ID, "in", cashiersSliced)
                ]
            })
            result.push(...items)
        }
    }
    return result
}

export const updateCompanyChargeById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.COMPANIES_CHARGES, id: id, data: data })
}

export const removeCompanyChargeById = async ({ id }) => {
    await deleteDoc({ collection: Collection.COMPANIES_CHARGES, id: id })
}